<template>
  <div class="passess-posession-section">
    <div class="columns is-desktop is-vcentered is-centered">
      <div class="column">
        <div id="chart">
          <PassesDonutBar :data="passesDonutDataProcessed" />
        </div>
      </div>
      <div class="column">
        <div class="posession">
          <div class="posession-title has-text-left">
            {{ $t('passes_possession.possession') }}
          </div>
          <div class="posession-group">
            <div class="posession-section">
              <div class="posession-section-header has-text-left">
                {{ $t('passes_possession.last_game') }}
              </div>
              <div class="columns is-mobile">
                <div class="column is-2 has-text-right">A</div>
                <div class="column is-8">
                  <Progress
                    striped
                    :percentage="averageLastGame"
                    :text-inside="true"
                    :stroke-width="18"
                    stroke-color="#509208"
                    track-color="#f1f2f2"
                  />
                </div>
                <div class="column is-2 has-text-left">B</div>
              </div>
            </div>
            <div class="posession-section">
              <div class="posession-section-header has-text-left">
                {{ $t('passes_possession.tournament_average') }}
              </div>
              <div class="columns is-mobile">
                <div class="column is-2 has-text-right">A</div>
                <div class="column is-8">
                  <Progress
                    striped
                    :percentage="averageGames"
                    :text-inside="true"
                    :stroke-width="18"
                    stroke-color="#509208"
                  />
                </div>
                <div class="column is-2 has-text-left">B</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PassesDonutBar from '@/components/Elements/Charts/Donut/Passes';
import Progress from 'vue-multiple-progress';
import { mapGetters, mapState } from 'vuex';
import teamStatsPlayIndexes from '@/data/team/teamStatsPlayIndexes';
const INDEXES = teamStatsPlayIndexes();

export default {
  name: 'PassesAndPoseesion',
  components: {
    Progress,
    PassesDonutBar,
  },
  props: {
    passesDonutData: {
      type: Array,
      default: () => [0, 0, 0],
    },
  },
  data() {
    return {
      teamId: parseInt(this.$route.params.teamId),
      categories: [2, 3, 20, 21],
    };
  },
  computed: {
    ...mapGetters({
      seasonId: 'filterGeneral/getSeasonId',
      playingAs: 'filterGeneral/getPlayingAs',
      getGamesPlayedByTeam: 'filterGeneral/getGamesPlayedByTeam',
    }),
    ...mapGetters({ games: 'gamesGeneral/seasonGamesPlayed' }),
    ...mapGetters('teamsPosession', { playsStack: 'getPlaysStack' }),
    ...mapState('teamsPosession', { playsBase: 'basePlaysStack' }),
    teamGames() {
      return this.games
        .filter(game => game.home_team === this.teamId || game.visiting_team === this.teamId)
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    },
    lastGame() {
      if (!this.playingAs) return this.teamGames[0];
      if (this.playingAs === 1) return this.teamGames.find(tg => tg.home_team === this.teamId);
      if (this.playingAs === 2) return this.teamGames.find(tg => tg.visiting_team === this.teamId);
    },
    teamPassesLastGame() {
      if (!this.lastGame) return 0;
      return this.playsBase.filter(play => {
        return (
          play[INDEXES.teamId] === this.teamId &&
          play[INDEXES.gameId] === this.lastGame.game_id &&
          this.categories.includes(play[INDEXES.categoryId])
        );
      }).length;
    },
    rivalPassesLastGame() {
      if (!this.lastGame) return 0;
      return this.playsBase.filter(play => {
        return (
          play[INDEXES.teamId] !== this.teamId &&
          play[INDEXES.gameId] === this.lastGame.game_id &&
          this.categories.includes(play[INDEXES.categoryId])
        );
      }).length;
    },
    averageLastGame() {
      if (!this.lastGame) return 0;
      return Math.round((this.teamPassesLastGame * 100) / (this.teamPassesLastGame + this.rivalPassesLastGame)) || 0;
    },
    teamPassesGames() {
      if (!this.playsStack) return 0;
      return (
        this.playsStack.filter(play => {
          return play[INDEXES.teamId] === this.teamId && this.categories.includes(play[INDEXES.categoryId]);
        }).length / this.gamesPlayed
      );
    },
    rivalPassesGames() {
      if (!this.playsStack) return 0;
      return (
        this.playsStack.filter(play => {
          return play[INDEXES.teamId] !== this.teamId && this.categories.includes(play[INDEXES.categoryId]);
        }).length / this.gamesPlayed
      );
    },
    averageGames() {
      if (!this.playsStack) return 0;
      return +Math.round((this.teamPassesGames * 100) / (this.teamPassesGames + this.rivalPassesGames)).toFixed(2) || 0;
    },
    gamesPlayed() {
      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;
    },
    passesDonutDataProcessed() {
      return this.passesDonutData.map(p => +(p / this.gamesPlayed).toFixed(2));
    },
  },
  watch: {
    seasonId() {
      this.getGamesBySeason();
    },
  },
  methods: {
    getGamesBySeason() {
      this.$store.dispatch('teamsGeneral/fetchGamesBySeason');
    },
  },
};
</script>

<style scoped>
#chart {
  /* width: 500px; */
  margin: 0 auto;
}
.passess-posession-section {
  border-radius: 21px;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}

.posession {
  padding: 30px;
}
.posession > .posession-title {
  font-size: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.96;
  letter-spacing: normal;
  color: #808285;
}
.posession-group {
  margin-left: 40px;
  margin-right: 20px;
}
.posession-section {
  height: 121px;
  border-radius: 17px;
  border: solid 1px #d8d8d8;
  background-color: #ffffff;
}
.posession-section:last-child {
  margin-top: 30px;
}
.posession-section-header {
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.7;
  letter-spacing: normal;
  color: #808285;
}
@media (min-width: 200px) {
  .posession-section-header {
    font-size: 16px;
    padding-left: 20px;
  }
}
@media (min-width: 400px) {
  .posession-section-header {
    font-size: 18px;
    padding-left: 37px;
  }
}
@media (min-width: 800px) {
  .posession-section-header {
    font-size: 20px;
    padding-left: 47px;
  }
}
.dona {
  width: 100px;
}
</style>
